import React from "react";

export default function WebsiteFooter() {
  return (
    <footer
      style={{
        width: "100%",
        padding: "2rem 0 1.2rem 0",
        background: "#f9fafb",
        borderTop: "1.5px solid #e5e7eb",
        textAlign: "center",
        color: "#6b7280",
        fontSize: "1rem",
        marginTop: "2rem",
      }}
    >
      <div style={{ marginBottom: "0.5rem", fontWeight: 500 }}>
        &copy; {new Date().getFullYear()} John Jackson
      </div>
      <div>
        <a
          href="https://github.com/JohnGJackson0"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#2563eb",
            textDecoration: "underline",
            fontWeight: 500,
          }}
        >
          GitHub
        </a>
      </div>
    </footer>
  );
}
